/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { Injectable, PipeTransform } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';


import { DecimalPipe } from '@angular/common';
import { debounceTime, delay, switchMap, tap } from 'rxjs/operators';
import { SortColumn, SortDirection } from '../shared/directives/sortable.directive';
import { Solicitacao } from 'app/models/Solicitacao';
import { ApiService, URLS } from './api.service';
import { environment } from 'environments/environment';
import { isNullOrUndefined } from 'util';
import { definirNomeAndamentosTiposPorSituacao } from 'app/shared/utils/definir_nome_andamentos_tipo';
import { definirIconeSolicitacao } from 'app/shared/utils/definir_icone';
import { Unidade } from 'app/models/Unidade';

interface SearchResult {
  solicitacoes: Solicitacao[];
  total: number;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
}

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(solicitacoes: Solicitacao[], column: SortColumn, direction: string): Solicitacao[] {
  if (direction === '' || column === '') {
    return solicitacoes;
  } else {
    return [...solicitacoes].sort((a, b) => {
      const res = compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
}

function matches(solicitacao: Solicitacao, term: string, pipe: PipeTransform) {
  return solicitacao.situacaoView.toLowerCase().includes(term.toLowerCase())
    // || pipe.transform(solicitacao.data_solicitacao).includes(term)
    || solicitacao.descricao.toLowerCase().includes(term.toLowerCase())
    || solicitacao.bairro.toLowerCase().includes(term.toLowerCase())
    || solicitacao.logradouro.toLowerCase().includes(term.toLowerCase())
    || solicitacao.data_solicitacao.includes(term)
    // || pipe.transform(solicitacao.situacao_do_ultimo_andamento).includes(term)
    || solicitacao.protocolo.includes(term);
}

@Injectable()
export class MonitorService {
  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private _solicitacoes$ = new BehaviorSubject<Solicitacao[]>([]);
  private _total$ = new BehaviorSubject<number>(0);

  private mySolicitacoes: Solicitacao[] = [];
  private SOLICITACOES: Solicitacao[] = [];
  unidades: Unidade[] = [];


  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };

  constructor(
    private pipe: DecimalPipe,
    private apiService: ApiService,

  ) {

    // this.getSolicitacoesFiltroInicial();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      debounceTime(200),
      switchMap(() => this._search()),
      delay(200),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      this._solicitacoes$.next(result.solicitacoes);
      this._total$.next(result.total);
    });
    this.getUnidades();
    setInterval(() => this.getListFiltroInicial(), 20000);
  }

  getListFiltroInicial() {
    let lastPositionArray = array => array[array.length - 1];
    let vm = this;
    this.apiService.get(URLS.SOLICITACOES.GET_SOLICITACOES_FILTRO_INICIAL, '', environment.urlLaravel)
      .subscribe(data => {
        // let unidade: Unidade;
        // let unidade_sigla = "";
        for (let i: number = 0; i < data.length; i++) {
          // if (data[i].unidades_id === null) {
          //   unidade_sigla = "S/UND";
          // } else {
          //   unidade = vm.unidades.find(x => x.id === data[i].unidades_id);
          //   unidade_sigla = unidade.sigla;
          // }
          data[i].situacaoView = definirNomeAndamentosTiposPorSituacao(data[i].situacao_do_ultimo_andamento);
          data[i].icon = definirIconeSolicitacao(data[i].solicitacoes_tipo_id, data[i].situacao_do_ultimo_andamento);
          // data[i].unidade = unidade_sigla;
        }
        this.mySolicitacoes = data;
        this._search$.next();
      });
  }

  get solicitacoes$() { return this._solicitacoes$.asObservable(); }

  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }

  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: SortColumn) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }


  private _search(): Observable<SearchResult> {
    const { sortColumn, sortDirection, pageSize, page, searchTerm } = this._state;

    // 1. sort
    let solicitacoes = sort(this.mySolicitacoes, sortColumn, sortDirection);

    // 2. filter
    solicitacoes = solicitacoes.filter(solicitacao => matches(solicitacao, searchTerm, this.pipe));
    const total = solicitacoes.length;

    // 3. paginate
    solicitacoes = solicitacoes.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    return of({ solicitacoes, total });
    // return of({solicitacoes, total} as SearchResult);
  }

  getUnidades() {
    let vm = this
    this.apiService.get(URLS.UNIDADES.GET_UNIDADES_ENDERECOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          vm.unidades = data
        },
        function (error) {
          console.log(error);
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/monitor.service.ts